<style lang="scss">
  @import './index.scss';
</style>
<template>
  <div class="scene-analysis">
    <h1 class="scene-analysis-title">{{ $t('sceneAnalysis.title') }}</h1>
    <div class="scene-analysis-overview">
      <panelMove
        :userCount="overviewMetric.totalVisit"
        :tooltipTitle="$t('sceneAnalysis.overview.totalTimes')"
        :tooltipContent="$t('sceneAnalysis.explain.totalVisit')"
        ></panelMove>
      <panelMove
        :userCount="overviewMetric.topOneScene.sceneName"
        :stringCount="overviewMetric.topOneScene.sceneRatio"
        :tooltipTitle="$t('sceneAnalysis.overview.topScene')"
        :tooltipContent="$t('sceneAnalysis.explain.noOneSceneAndRatio')"
        ></panelMove>
    </div>
    <div class="scene-analysis-content">
      <Row class-name="scene-analysis-content-title">
        <Col span="12" class-name="scene-analysis-content-title-details">
        </Col>
      </Row>
      <Tabs
        :value="disTabs"
        @on-click="onChangeTabs">
        <Tab-pane
          :label="$t('sceneAnalysis.sceneDis.tabs')"
          name="sceneDis">
            <pie-move
              :legend-note="$t('sceneAnalysis.sceneDis.legendNote')"
              :total-visit="overviewMetric.totalVisit"
              ref="sceneDis">
            </pie-move>
        </Tab-pane>
        <Tab-pane
          :label="$t('sceneAnalysis.firstSceneDis.tabs')"
          name="firstSceneDis">
            <pie-move
              :legend-note="$t('sceneAnalysis.firstSceneDis.legendNote')"
              :total-visit="overviewMetric.firstTotalVisit"
              ref="firstSceneDis">
            </pie-move>
        </Tab-pane>
      </Tabs>
    </div>
    <!-- 场景分布详情表格部分 -->
    <div class="scene-analysis-view">
      <!-- 表格标题及操作按钮 -->
      <Row
        class="scene-analysis-view-title"
        style="border-bottom: none;">
        <i-col span="12" class="scene-analysis-view-title-h3">{{ $t('sceneAnalysis.title') }}</i-col>
        <i-col span="12" class="scene-analysis-view-title-details">
          <!-- 搜索框 -->
          <i-input
            class="scene-analysis-view-title-details-input"
            icon="ios-search"
            :placeholder="$t('filter.search')"
            style="width:160px"
            v-model="filterKey">
          </i-input>
          <!-- 下载按钮 -->
          <span
            class="iconfont icon-download tm-icon-font hover-style tm-icon-font-position"
            style="margin-left:10px"
            @click="exportData('sceneList')">
          </span>
          <Poptip trigger="hover" class="tab-pop" placement="bottom-end">
              <span
                class="iconfont icon-help tm-icon-font hover-style tm-icon-font-portrait"
                style="margin-left:10px;">
              </span>
              <div slot="title">{{ $t('sceneAnalysis.explain.title') }}</div>
              <div
                slot="content"
                v-for="(eachColumn, index) in tableColumnData"
                v-if="eachColumn.key !== 'operate'">
                  <p><span>{{ eachColumn.title }}: </span>{{ $t(`sceneAnalysis.explain.${eachColumn.key}`) }}</p>
              </div>
          </Poptip>
        </i-col>
      </Row>
      <div class="scene-analysis-view-table">
        <table-move
          style="min-height:500px;"
          v-if="tableColumnData.length > 0"
          :noData="pageNoData"
          :change-data="tableContentData"
          :table-columns="tableColumnData"
          :filter-key="['sceneID', 'sceneDes']"
          :filter-value="filterKey"
          ref="sceneList"
          @on-table-move-sort="sortTable">
        </table-move>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import panelMove from '../../components/panel-move/index';
  import pieMove from '../../components/pie-move/pie-move';
  import tableMove from '../../components/table-move/table-move';
  import sortData from '../../filters/sort-table-data';
  import bus from '../../libs/bus';
  import util from '../../libs/util';


  export default {
    data() {
      const self = this;
      return {
        overviewMetric: {
          totalVisit: '--', // 总访问次数
          firstTotalVisit: '--', // 首次总访问次数
          topOneScene: { // No.1场景及其比例
            sceneName: '--',
            sceneRatio: '',
          },
        },
        disTabs: 'sceneDis',
        sceneDis: {
          show: false,
        },
        firstSceneDis: {
          show: false,
        },
        disAPIMetrics: {
          FE: ['sceneDis', 'firstSceneDis'],
          BE: ['viewAmt', 'firstViewAmt'],
        },
        tableColumnData: self.setTableColumns(),
        tableContentData: [],
        timePeriod: 0,
        filterKey: '',
        saveTableData: '',
        sceneListParam: [],
        pageNoData: this.$t('common.loading'),
      };
    },
    components: {
      panelMove,
      pieMove,
      tableMove,
    },
    methods: {
      init() {
        this.clearData();
        // 重置各个chart组件
        Object.keys(this.$refs).forEach((x) => {
          if (this.$refs[x].clearData) this.$refs[x].clearData();
        });
        // 场景分布tab下刷新
        if (this.disTabs === 'sceneDis') {
          this.getParallelOverviewAndTopTen(this.disTabs);
          this.tableDataInit();
        } else { // 首次访问时场景分布tab下刷新
          this.getParallelOverview();
          this.getParallelTopTenAndTable(this.disTabs);
        }
      },
      /**
       * 并行发送请求：总访问次数, Top10场景
       */
      getParallelOverviewAndTopTen(key) {
        const self = this;
        axios.all([self.getOverviewDataTotal(), self.getTopTenScene()])
          .then(axios.spread((resTotal, resTop) => {
            self.setOverviewDataTotal(resTotal.viewAmt[0].value);
            self.setOverviewDataTopOne(resTop);
            self.setTopTenScene(resTop, key);
          }))
          .catch(() => {
            self.$Message.error({
              content: self.$t('sceneAnalysis.error'),
              duration: 3,
            });
            self.pieChartErrorView(key);
          });
      },
      /**
       * 并行发送请求：Top10场景, 场景列表
       */
      getParallelTopTenAndTable(key) {
        const self = this;
        axios.all([self.getTopTenScene(), self.getSceneTableData()])
          .then(axios.spread((resTop, resTable) => {
            self.setSceneTableData(resTable);
            self.setTopTenScene(resTop, key);
          }))
          .catch(() => {
            self.$Message.error({
              content: self.$t('sceneAnalysis.error'),
              duration: 3,
            });
          });
      },
      /**
       * 并行发送请求：总访问次数, Top1指标
       */
      getParallelOverview() {
        const self = this;
        axios.all([self.getOverviewDataTotal(), self.getOverviewDataTopOne()])
          .then(axios.spread((resTotal, resOne) => {
            self.setOverviewDataTotal(resTotal.viewAmt[0].value);
            self.setOverviewDataTopOne(resOne);
          }))
          .catch(() => {
            self.$Message.error({
              content: self.$t('sceneAnalysis.error'),
              duration: 3,
            });
          });
      },
      getCommonRequestBody() {
        const conditions = bus.conditions;
        const params = {
          developerId: bus.developerid.toString(),
          productId: bus.productInfo.productid,
          platformIds: bus.platform, // Array
          partnerIds: conditions.partner.length === 0 ? undefined : conditions.partner, // Array
          versions: conditions.version.length === 0 ? undefined : conditions.version, // Array
          startTime: bus.selectedDate[0].split('-').join('').slice(2),
          endTime: bus.selectedDate[1].split('-').join('').slice(2),
        };
        return params;
      },
      /**
       * 获取头部总访问次数指标
       */
      getOverviewDataTotal() {
        const params = this.getCommonRequestBody();
        params.metrics = ['viewAmt'];
        return util.ajax.post('/app/rest/miniApp/query', params);
      },
      /**
       * 设置头部总访问次数指标
       */
      setOverviewDataTotal(volumn) {
        this.overviewMetric.totalVisit = volumn;
      },
      /**
       * 获取头部No.1场景指标
       */
      getOverviewDataTopOne() {
        const params = this.getCommonRequestBody();
        params.metrics = [this.disAPIMetrics.BE[0]];
        params.groupBy = 'sceneId';
        params.verbose = '1';
        params.aggr = '1';
        return util.ajax.post('/app/rest/miniApp/query', params);
      },
      /**
       * 设置头部No.1场景指标
       * @param {[Array]} res   [API接口返回的原始数据]
       */
      setOverviewDataTopOne(res) {
        if (res.length > 0) {
          const sortedData = res.sort((a, b) => b.viewAmt - a.viewAmt);
          const topOneScene = sortedData[0];
          this.overviewMetric.topOneScene.sceneName = topOneScene.sceneNm;
          const topOneRatio =
            (100 * (topOneScene.viewAmt / this.overviewMetric.totalVisit)).toFixed(2);
          this.overviewMetric.topOneScene.sceneRatio = `${topOneRatio}%`;
        }
      },
      /**
       * 渲染当前场景分布的tab
       * @param {[String]} key   [当前 tabs标示]
       */
      onChangeTabs(key) {
        const self = this;
        self.disTabs = key;
        // 如果点击tab已经实例化，则直接返回
        if (this[key].show) return;
        self.pieDataInit(key);
      },
      /**
       * 获取top10场景分布数据
       * @param {[String]} key   [当前 tabs标示]
       */
      getTopTenScene() {
        const params = this.getCommonRequestBody();
        // const metric = this.disAPIMetrics.BE[this.disAPIMetrics.FE.indexOf(key)];
        params.metrics = this.disAPIMetrics.BE;
        params.groupBy = 'sceneId';
        params.verbose = '1';
        params.aggr = '1';
        return util.ajax.post('/app/rest/miniApp/query', params);
      },
      /**
       * 过滤并加工top10场景分布数据
       * @param {[Array]} res   [场景分布原始数据]
       */
      setTopTenScene(res, key) {
        const self = this;
        // 返回空[]时不显示环形图
        if (res.length === 0) {
          const refsDom = this.$refs[key];
          refsDom.spinShow = false; // 隐藏spin
          refsDom.noData = true;
          return;
        }
        // 访问总次数为0是不显示环形图
        if (key === 'firstSceneDis' && self.overviewMetric.totalVisit === 0) {
          const refsDom = this.$refs[key];
          refsDom.spinShow = false; // 隐藏spin
          refsDom.noData = true;
          return;
        }
        // 首次访问总次数为0是不显示环形图
        if (key === 'firstSceneDis' && [0, '--'].includes(self.overviewMetric.firstTotalVisit)) {
          const refsDom = this.$refs[key];
          refsDom.spinShow = false; // 隐藏spin
          refsDom.noData = true;
          return;
        }
        const data = res;
        // 获取当前指标名称: viewAmt或者firstViewAmt
        const currentMetric = this.disAPIMetrics.BE[this.disAPIMetrics.FE.indexOf(key)];
        // 按照viewAmt或者firstViewAmt排序
        const sortedData = data.sort((a, b) => b[currentMetric] - a[currentMetric]).slice(0, 9);
        // 计算除去top10之外的其他
        const otherScene = {
          sceneId: 'other',
          sceneNm: self.$t('sceneAnalysis.other'),
        };
        if (key === 'sceneDis') {
          otherScene.viewAmt = '0';
        } else {
          otherScene.firstViewAmt = '0';
        }
        let topTenVisitSum = 0;
        sortedData.forEach((eachScene) => {
          topTenVisitSum += parseInt(eachScene[currentMetric], 10);
        });
        if (key === 'sceneDis') {
          otherScene.viewAmt = self.overviewMetric.totalVisit - topTenVisitSum;
        } else {
          otherScene.firstViewAmt = self.overviewMetric.firstTotalVisit - topTenVisitSum;
        }
        sortedData.push(otherScene);
        // 计算百分比比例
        const ratioData = sortedData.map((eachScene) => {
          const temp = eachScene;
          if (key === 'sceneDis') {
            temp.ratio = (100 * (temp[currentMetric] / this.overviewMetric.totalVisit)).toFixed(2);
          } else {
            temp.ratio = (100 * (temp[currentMetric] / this.overviewMetric.firstTotalVisit))
              .toFixed(2);
          }
          return temp;
        });
        // 构造echart需要的数据结构
        const pieLegendData = [];
        const pieSeriesData = [];
        ratioData.forEach((eachScene) => {
          pieLegendData.push({
            name: eachScene.sceneNm,
            icon: 'circle',
            value: eachScene[currentMetric],
            per: eachScene.ratio,
          });
          pieSeriesData.push({
            value: eachScene[currentMetric],
            name: eachScene.sceneNm,
          });
        });
        self.pieChartRender(key, pieLegendData, pieSeriesData);
      },
      /**
       * 环形组件数据获取
       * @param {[String]} key   [当前 tabs标示]
       */
      pieDataInit(key) {
        // 获取top 10场景数据
        const self = this;
        self.getTopTenScene().then((res) => {
          self.setTopTenScene(res, key);
        })
        .catch(() => {
          self.pieChartErrorView(key);
        });
      },
      /**
       * 环形组件渲染
       * @param {[String]} key   [当前 tabs标示]
       * @param {[Array]} legend   [legend数据]
       * @param {[Array]} series   [series数据]
       */
      pieChartRender(key, legend, series) {
        const refsDom = this.$refs[key];
        this[key].show = true; // mark该tab已经实例化
        refsDom.spinShow = false; // 隐藏spin
        refsDom.initChart(legend, series); // 调用pie-move组件的initChart函数
      },
      /**
       * 数据请求失败图表提示
       * @param {[String]} key   [当前 tabs标示]
       */
      pieChartErrorView(key) {
        this.$refs[key].spinShow = false;
        this.$refs[key].errorSpin = true;
      },
      tableDataInit() {
        const self = this;
        self.getSceneTableData().then((res) => {
          // sessionStorage的参数
          self.sceneListParam = res.map(eachScene => ({
            sceneId: eachScene.sceneId,
            sceneNm: eachScene.sceneNm,
          }));
          self.setSceneTableData(res);
        })
        .catch(() => {
          self.$Message.error({
            content: self.$t('sceneAnalysis.error'),
            duration: 3,
          });
        });
      },
      /**
       * 数据全部场景table数据
       */
      getSceneTableData() {
        const params = this.getCommonRequestBody();
        params.metrics = ['viewAmt', 'viewDeviceAmt', 'newDeviceViewAmt', 'pageAccessTimes'];
        params.groupBy = 'sceneId';
        params.verbose = '1';
        params.aggr = '1';
        return util.ajax.post('/app/rest/miniApp/query', params);
      },
      /**
       * 设置全部场景table数据
       */
      setSceneTableData(res) {
        const self = this;
        if (res.length === 0) {
          self.pageNoData = self.$t('common.nodata');
          return;
        }
        const data = res.sort((b, a) => a.viewAmt - b.viewAmt);
        // 计算日均访问次数、每设备访问次数
        let tempFirstTotal = 0;
        const currentPeriod = self.calculateTimePeriod();
        data.forEach((eachScene) => {
          self.tableContentData.push({
            sceneID: eachScene.sceneId,
            sceneDes: eachScene.sceneNm,
            visitNum: eachScene.viewAmt, //访问次数->打开次数
            pageAccessNum: eachScene.pageAccessTimes, //新增访问次数
            aveVisitNum: (eachScene.viewAmt / currentPeriod).toFixed(2),
            visitDev: eachScene.viewDeviceAmt,
            visitDevNum: eachScene.viewDeviceAmt === '0' ? 0 :
              (eachScene.viewAmt / eachScene.viewDeviceAmt).toFixed(2),
            newDev: eachScene.newDeviceViewAmt,
          });
          tempFirstTotal += parseInt(eachScene.newDeviceViewAmt, 10);
        });
        self.overviewMetric.firstTotalVisit = tempFirstTotal;
      },
      /**
       * 计算当前所选时间周期
       */
      calculateTimePeriod() {
        const startDay = new Date(bus.selectedDate[0]);
        const endDay = new Date(bus.selectedDate[1]);
        const timeDiff = endDay.getTime() - startDay.getTime();
        let dayDiff = timeDiff / (1000 * 3600 * 24);
        dayDiff += 1;
        return dayDiff;
      },
      goDetailPage(selectedScene) {
        this.$router.push({
          name: 'sceneDetail',
          params: {
            productid: this.$route.params.productid,
            sceneid: selectedScene.row.sceneID,
            sceneDes: selectedScene.row.sceneDes,
            sceneList: this.sceneListParam,
          },
        });
        sessionStorage.setItem('sceneAnalysis', JSON.stringify({
          sceneid: selectedScene.row.sceneID,
          sceneDes: selectedScene.row.sceneDes,
          sceneList: this.sceneListParam,
        }));
      },
      /**
       * 下载图表数据
       * @param  {[Sting]} str   [当前 Tabs 标示]
       */
      exportData(str) {
        const arg = str;
        const nameArg = `sceneAnalysis.${arg}`;
        const name = this.$t(nameArg);
        this.$refs[arg].exportTable(name);
      },
      clearData() {
        this.sceneDis = {
          show: false,
        };
        this.firstSceneDis = {
          show: false,
        };
        this.tableContentData = [];
        this.overviewMetric = {
          totalVisit: '--', // 总访问次数
          firstTotalVisit: '--', // 首次总访问次数
          topOneScene: { // No.1场景及其比例
            sceneName: '--',
            sceneRatio: '',
          },
        };
        this.pageNoData = this.$t('common.loading');
      },
      /**
       * 自定义排序
       * @param  {[Object]} obj [点击排序列内容]
       * @param {String} name [table-move 绑定的refs 表格数据前缀 例：ref为pageTable，则此表格绑定数据为pageTableData]
       */
      sortTable(obj, tableData) {
        const data = tableData;
        const list = sortData(obj, data);
        this.tableContentData = list;
      },
      setTableColumns() {
        const self = this;
        return [
          {
            title: self.$t('sceneAnalysis.tableColumn.sceneID'),
            key: 'sceneID',
            render(h, params) {
              return h('a', {
                style: {
                  cursor: 'pointer',
                },
                on: {
                  click: () => {
                    self.goDetailPage(params);
                  },
                },
              }, [
                params.row.sceneID,
              ]);
            },
          },
          {
            title: self.$t('sceneAnalysis.tableColumn.sceneDes'),
            key: 'sceneDes',
            render(h, params) {
              return h('a', {
                style: {
                  cursor: 'pointer',
                },
                on: {
                  click: () => {
                    self.goDetailPage(params);
                  },
                },
              }, [
                params.row.sceneDes,
              ]);
            },
          },
          //新增  访问次数
          {
            title: self.$t('sceneAnalysis.tableColumn.pageAccessTimes'),
            key: 'pageAccessNum',
            align: 'right',
          },
          //访问次数-->打开次数
          {
            title: self.$t('sceneAnalysis.tableColumn.visitTimes'),
            key: 'visitNum',
            sortable: 'custom',
            align: 'right',
          },
          {
            title: self.$t('sceneAnalysis.tableColumn.dayVisitTimes'),
            key: 'aveVisitNum',
            align: 'right',
          },
          {
            title: self.$t('sceneAnalysis.tableColumn.visitDev'),
            key: 'visitDev',
            align: 'right',
          },
          {
            title: self.$t('sceneAnalysis.tableColumn.devVisitTimes'),
            key: 'visitDevNum',
            align: 'right',
          },
          {
            title: self.$t('sceneAnalysis.tableColumn.newDev'),
            key: 'newDev',
            align: 'right',
          },
          {
            title: self.$t('sceneAnalysis.tableColumn.operate'),
            key: 'operate',
            align: 'right',
            render(h, params) {
              return h('a', {
                class: {
                  'iconfont': true,
                  'icon-Details': true,
                  'tm-icon-font': true,
                  'tm-icon-font-operation': true,
                },
                style: {
                  cursor: 'pointer',
                },
                on: {
                  click: () => {
                    self.goDetailPage(params);
                  },
                },
              });
            },
          },
        ];
      },
    },
    filters: {
      sortData,
    },
    mounted() {
      bus.$on('on-app-change', () => {
        this.init();
      });
      bus.$on('on-platform-change', () => {
        this.init();
      });
      bus.$on('on-conditions-change', () => {
        this.init();
      });
      bus.$on('on-date-change', () => {
        this.init();
      });
      bus.$on('on-change-lang', () => {
        this.tableColumnData = this.setTableColumns();
      });
      if (!bus.productInfo.productid) {
        return;
      }
      this.init();
    },
    beforeDestroy() {
      bus.$off('on-app-change');
      bus.$off('on-platform-change');
      bus.$off('on-conditions-change');
      bus.$off('on-date-change');
      bus.$off('on-change-lang', () => {
        this.tableColumnData = this.setTableColumns();
      });
    },
  };
</script>
